import React from 'react';
import { MSTeamsIcon, MSTeamsIconType } from 'msteams-ui-icons-react';
import { Colors } from 'msteams-ui-styles-core';
import { ButtonLabel } from '../../Shared/Styled';
import { WizardContext } from '../../../context/';

export interface WizardButtonProps {
  direction: 'back' | 'forward';
  label?: string;
  disabled?: boolean;
  onClick?: (opts: any) => any;
  theme?: string;
}

export const WizardButton = ({
  direction,
  label = direction === 'back' ? 'Back' : 'Next',
  onClick,
  disabled = false,
  theme = 'default',
}: WizardButtonProps): JSX.Element => {
  const buttonStyles = {
    border: 'none',
    backgroundColor: 'transparent',
    cursor: disabled ? 'auto' : 'pointer',
    padding: 0,
    fontFamily: '"Segoe UI", "Open Sans"',
    userSelect: 'none',
  } as React.CSSProperties;

  const buttonIconStyles = {
    display: 'inline-block',
    border: `1px solid ${determineBtnBorder(disabled, theme)}`,
    borderRadius: '50%',
    backgroundColor: determineBtnBg(disabled, theme),
    color: determineBtnTextIconColor(disabled, theme),
    width: '22px',
    height: '22px',
    lineHeight: '22px',
    fontSize: '12px',
    fontWeight: '500',
    cursor: disabled ? 'auto' : 'pointer',
    margin: '0',
  };

  const TeamsIcon = (
    <MSTeamsIcon
      iconType={
        direction === 'back'
          ? MSTeamsIconType.NavigationBackCentered
          : MSTeamsIconType.NavigationForwardCentered
      }
      style={buttonIconStyles}
    />
  );
  const TextEl = (
    <ButtonLabel disabled={disabled} themeStr={theme}>
      {label}
    </ButtonLabel>
  );
  return (
    <WizardContext.Consumer>
      {({ next, prev }) => (
        <button
          id={`wizard-${direction}`}
          disabled={disabled}
          style={
            direction === 'back'
              ? buttonStyles
              : { ...buttonStyles, ...{ marginLeft: 'auto' } }
          }
          onClick={() => {
            const action = direction === 'back' ? prev : next;
            if (onClick) {
              onClick(action);
            } else {
              action();
            }
          }}
        >
          {direction === 'back' ? (
            <React.Fragment>
              {TeamsIcon}
              {TextEl}
            </React.Fragment>
          ) : (
            <React.Fragment>
              {TextEl}
              {TeamsIcon}
            </React.Fragment>
          )}
        </button>
      )}
    </WizardContext.Consumer>
  );
};

const determineBtnBg = (disabled: boolean, theme: string) => {
  if (theme === 'dark')
    return disabled ? Colors.dark.gray08 : Colors.light.brand00;
  if (theme === 'contrast')
    return disabled ? Colors.highContrast.white : Colors.highContrast.green;
  return disabled ? Colors.light.white : Colors.light.brand00;
};

const determineBtnBorder = (disabled: boolean, theme: string) => {
  if (theme === 'dark')
    return disabled ? Colors.dark.gray08 : Colors.light.brand00;
  return disabled ? Colors.light.gray08 : Colors.light.brand00;
};

const determineBtnTextIconColor = (disabled: boolean, theme: string) => {
  if (theme === 'dark')
    return disabled ? Colors.dark.gray04 : Colors.dark.white;
  return disabled ? Colors.light.gray08 : Colors.light.white;
};
